import React, { useContext, useCallback,useState, useEffect } from 'react';
import { ViewModelForm ,ViewModelServiceContext, useDataRefresh} from 'gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import{
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalNextProvider,
    ButtonLink
} from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import styles from './PaperlessDistibutionComponent.module.scss';
import metadata from './PaperlessDistibutionComponent.metadata.json5';
import messages from './PaperlessDistibutionComponent.messages';
import { Link } from 'react-router-dom';



const PaperlessDistibutionComponent = (props) => {
    const {
        isOpen,
        authHeader,
        data,
        onReject,
        onResolve,
        history
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const [policyDocConsentValue, updatePolicyDocConsentValue] = useState(true);
    const [showNotification , setShowNotification]= useState(true);
    
   

    useEffect(() => {
      
    // only execute once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const updatePolicyDocEmailConsentValue = useCallback((value)=>{
        updatePolicyDocConsentValue(value);
    },[updatePolicyDocConsentValue,policyDocConsentValue])

//    const policyDocConsentMessage =()=>{
//         return (
//             <div><span>"Consent to Electronic Delivery:"</span>
//             <span>To serve you better, some of your policies have been moved to electronic document distribution. You agree that we may deliver all policy declaration documents, invoices, and other documents and information to you by electronic means. You agree to tell us right away if you change your email address so we can send information to the new address?"</span></div>
//         )
//    };

    const handleClose = useCallback(() => {
        onResolve(policyDocConsentValue);
        onReject();
    }, [onReject,policyDocConsentValue]);

    const optOut =useCallback(() => {
        //updatePolicyDocEmailConsentValue(false);
        onReject();
        const location = {
            pathname: "/go-paperless",
            state: showNotification || {}
         }
        history.push(location);
      
    },[]);

    const overrideProps = {
        policyDocEmailConsentField: {
            value: policyDocConsentValue,
            label: `${translator(messages.consentTitle)}\n${translator(messages.consentDescription)}`,
            disabled: policyDocConsentValue
        } 
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            updatePolicyDocEmailConsentValue,
            optOut
        }
    };

    return (
        <ModalNext className={styles.paperlessModalBoxWidth} isOpen={isOpen}>
            <ModalHeader
             title={translator(messages.setPaperLessTitle)} 
             status ='success'
             icon="mi-mail" />
            <ModalBody>
                <ViewModelForm
                    uiProps={metadata.componentContent.content}
                    model={data}
                    overrideProps={overrideProps}
                    // onModelChange={handleVMChange}
                    // onValueChange ={handleChange}
                    callbackMap={resolvers.resolveCallbackMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </ModalBody>
            <ModalFooter>
            <Button onClick={optOut}  type="secondary" icon="mi-description">
                  {translator(messages.optOut)}
                </Button>
                <Button onClick={handleClose} icon="mi-eco">
                {translator(messages.agree)}
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

PaperlessDistibutionComponent.propTypes = {
    authHeader: PropTypes.shape({
        Authorization: PropTypes.string
    }).isRequired,
    onResolve: PropTypes.func.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
};
PaperlessDistibutionComponent.defaultProps = {
    isOpen: false,
    onReject: _.noop,
};
export default withAuthenticationContext(PaperlessDistibutionComponent);
